(function () {
  var MOBILE_QUERY = '(max-width: 589px)';

  function getHeaderOffset() {
    return window.matchMedia(MOBILE_QUERY).matches ? '84px' : '116px';
  }

  function syncHeaderOffset() {
    var offset = getHeaderOffset();
    document.documentElement.style.setProperty('--site-header-offset', offset);
    document.documentElement.style.setProperty('--byob-shop-header-offset', offset);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncHeaderOffset);
  } else {
    syncHeaderOffset();
  }

  window.addEventListener('resize', syncHeaderOffset);
})();
